module.exports = __webpack_public_path__ + "img/blue_064.7f8985e2.png";